import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ObservableMedia } from '@angular/flex-layout';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { AclService } from 'ng2-acl/dist';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FuseMatchMediaService } from '@fuse/services/match-media.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseConfigService } from '@fuse/services/config.service';

import { navigation } from 'app/navigation/navigation';

import { locale as translationEnglish } from './i18n/en';
import { locale as translationRussian } from './i18n/ru';

@Component({
    selector   : 'fuse-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls  : ['./shortcuts.component.scss']
})
export class FuseShortcutsComponent implements OnInit, OnDestroy
{
    shortcutItems: any[] = [];
    navigationItems: any[];
    filteredNavigationItems: any[];
    searching = false;
    mobileShortcutsPanelActive = false;
    toolbarColor: string;
    matchMediaSubscription: Subscription;
    onConfigChanged: Subscription;

    @ViewChild('searchInput') searchInputField;
    @ViewChild('shortcuts') shortcutsEl: ElementRef;

    constructor(
        private renderer: Renderer2,
        private observableMedia: ObservableMedia,
        private fuseMatchMedia: FuseMatchMediaService,
        private fuseNavigationService: FuseNavigationService,
        private fuseTranslationLoader: FuseTranslationLoaderService,
        private fuseConfig: FuseConfigService,
        private cookieService: CookieService,
        private translateService: TranslateService,
        private aclService: AclService
    )
    {
        this.fuseTranslationLoader.loadTranslations(translationEnglish, translationRussian);
        this.filteredNavigationItems = this.navigationItems = this.fuseNavigationService.getFlatNavigation(navigation);

        this.onConfigChanged =
            this.fuseConfig.onConfigChanged
                .subscribe(
                    (newSettings) => {
                        this.toolbarColor = newSettings.colorClasses.toolbar;
                    }
                );
    }

    ngOnInit()
    {
        const cookieExists = this.cookieService.check('BFB.shortcuts');

        if ( cookieExists )
        {
            this.shortcutItems = JSON.parse(this.cookieService.get('BFB.shortcuts'));
            this.reduceNavByPermissions();
        }
        else
        {
            // User's shortcut items
            this.shortcutItems = [
                {
                    'title': 'Dashboard',
                    'translate': 'NAV.DASHBOARD.TITLE',
                    'type' : 'nav-item',
                    'icon' : 'dashboard',
                    'url'  : '/'
                },
                {
                    'title': 'Calendar',
                    'translate': 'NAV.CALENDAR.TITLE',
                    'type' : 'nav-item',
                    'icon' : 'today',
                    'url'  : '/calendar',
                },
                {
                    'id'   : 'profile',
                    'title': 'Profile',
                    'translate': 'NAV.PROFILE.TITLE',
                    'type' : 'item',
                    'icon' : 'account_box',
                    'url'  : '/profile'
                }
            ];
        }

        this.matchMediaSubscription =
            this.fuseMatchMedia.onMediaChange.subscribe(() => {
                if ( this.observableMedia.isActive('gt-sm') )
                {
                    this.hideMobileShortcutsPanel();
                }
            });
    }

    reduceNavByPermissions() {
        for (let i = 0; this.shortcutItems.length > i; i++) {
            if (this.shortcutItems[i].permisssion) {
                if (!this.aclService.can(this.shortcutItems[i].permisssion)) {
                    this.shortcutItems.splice(i, 1);
                }
            }
        }
    }

    ngOnDestroy()
    {
        this.matchMediaSubscription.unsubscribe();
        this.fuseNavigationService.clearFlatNavigation();
    }

    search(event)
    {
        const value = event.target.value.toLowerCase();

        if ( value === '' )
        {
            this.searching = false;
            this.filteredNavigationItems = this.navigationItems;

            return;
        }

        this.searching = true;
        this.filteredNavigationItems = [];
        this.navigationItems.forEach((navigationItem) => {
            this.translateService.get(navigationItem.translate)
            .subscribe((res) => {
               if (res.toLowerCase().indexOf(value) !== -1) {
                this.filteredNavigationItems.push(navigationItem);
               }
            });
        });
    }

    toggleShortcut(event, itemToToggle)
    {
        event.stopPropagation();

        for ( let i = 0; i < this.shortcutItems.length; i++ )
        {
            if ( this.shortcutItems[i].url === itemToToggle.url )
            {
                this.shortcutItems.splice(i, 1);

                // Save to the cookies
                this.cookieService.set('BFB.shortcuts', JSON.stringify(this.shortcutItems));

                return;
            }
        }

        this.shortcutItems.push(itemToToggle);

        // Save to the cookies
        this.cookieService.set('BFB.shortcuts', JSON.stringify(this.shortcutItems));
    }

    isInShortcuts(navigationItem)
    {
        return this.shortcutItems.find(item => {
            return item.url === navigationItem.url;
        });
    }

    onMenuOpen()
    {
        setTimeout(() => {
            this.searchInputField.nativeElement.focus();
        });
    }

    showMobileShortcutsPanel()
    {
        this.mobileShortcutsPanelActive = true;
        this.renderer.addClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }

    hideMobileShortcutsPanel()
    {
        this.mobileShortcutsPanelActive = false;
        this.renderer.removeClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
    }
}



// WEBPACK FOOTER //
// ./src/@fuse/components/shortcuts/shortcuts.component.ts